import "./Images.scss";
import { Box, Button, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Image } from "../../models/images";
import { useHttp } from "../../hooks/useHttp";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import { useNavigate } from "react-router";
import { ImagesModal } from "../../components/ImagesModel/ImagesModal";

export const Images = () => {
  const [images, setImages] = useState<Image[]>([]);
  const [selectedImage, setSelectedImage] = useState<Image | null>(null);
  const { trigger: fetchImages } = useHttp<Image[]>("/images");

  useEffect(() => {
    const cachedImages = sessionStorage.getItem("cachedImages");
    if (cachedImages) {
      setImages(JSON.parse(cachedImages));
    } else {
      fetchImages({
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
        params: {
          sessionId: sessionStorage.getItem("sessionId") || "",
        },
      }).then((response) => {
        if (response) {
          setImages(response);
          sessionStorage.setItem("cachedImages", JSON.stringify(response));
        }
      });
    }
  }, [fetchImages]);

  return (
    <div className="images">
      {selectedImage && (
        <ImagesModal image={selectedImage} open={!!selectedImage} handleClose={() => setSelectedImage(null)} />
      )}
      <Box className={"tasks-header"}>
        <Typography variant={"h2"} className={"tasks-header-title"}>
          Images
        </Typography>
      </Box>
      <Box className="images-list">
        {images.map((image) => (
          <ImageComponent key={image.id} image={image} selectImage={() => setSelectedImage(image)} />
        ))}
      </Box>
    </div>
  );
};

interface ImageComponentProps {
  image: Image;
  selectImage: () => void;
}

const ImageComponent = ({ image, selectImage }: ImageComponentProps) => {
  const navigate = useNavigate();

  return (
    <Box className="images-item" onClick={selectImage}>
      <Box className="images-item-image">
        <img src={image.base64Image} alt={image.name} />
      </Box>
      <Typography className="images-item-header" variant="body1" component="p">
        {image.name}
      </Typography>
      <Typography variant="body2" component="p">
        {image.description}
      </Typography>
      <Box className="images-item-actions">
        <PlayArrowIcon className="images-item-actions-run" onClick={() => navigate("/tasks?create=" + image.id)} />
      </Box>
    </Box>
  );
};
